import {Component, ViewChild} from '@angular/core';
import {IonicPage, NavController, NavParams, Slides} from 'ionic-angular';
import {IntroInsurranceValidationPage} from "../intro-insurrance-validation/intro-insurrance-validation";
import {LoginPage} from "../login/login";
import {IntroNamePage} from "../intro-name/intro-name";
import {InsuranceProvider} from "../../providers/insurance/insurance";
import {ContentTranslationProvider} from "../../providers/content-translation/content-translation";
import {WheelSelector} from "@ionic-native/wheel-selector";
import {SplashScreen} from "@ionic-native/splash-screen";
import {AppPartnerSelectionPopupPage} from "../app-partner-selection-popup/app-partner-selection-popup";
import {IntroWizardServiceProvider} from "../../providers/intro-wizard-service/intro-wizard-service";
import {IntroAokSelectionPage} from "../intro-aok-selection/intro-aok-selection";
import {RegisterPage} from "../register/register";

/**
 * Generated class for the IntroWelcomePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-intro-welcome',
  templateUrl: 'intro-welcome.html',
})
export class IntroWelcomePage {
  @ViewChild(Slides) slides: Slides;

  visibleCalculator: boolean = false;
  loginPage: any = LoginPage;
  insurranceValidationPage: any = RegisterPage;
  selectedCompany: any;
  selectedCompanyObject: any;
  companies: Array<any> = [];
  rootClass: string = 'current-step-0';


  currentSlide: number;

  constructor(public navCtrl: NavController, public navParams: NavParams, public insurance: InsuranceProvider, public contentTranslation: ContentTranslationProvider, public selector: WheelSelector, public splash: SplashScreen, public introWizard: IntroWizardServiceProvider) {


  }

  companyChanged(company) {
    this.selectedCompanyObject = company;
    console.log(this);
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad IntroWelcomePage');

    this.introWizard.partnerCode = '';
    this.slides.lockSwipes(false);
    this.splash.hide();
  }

  ngAfterViewInit() {
    this.slides.lockSwipes(true);
  }

  nextPage() {
    /*if(this.slides.getActiveIndex() == 0 && this.introWizard.partnerCode===null) {
      this.slides.lockSwipes(false);
      this.navCtrl.push(IntroAokSelectionPage);
      setTimeout(() => {
        this.introWizard.partnerCode = '';
      }, 100);
      setTimeout(() => {
        this.slides.slideNext();
      }, 1000);
      return ;
    }*/

    console.log(this.slides.getActiveIndex(), this.introWizard.bgm, this.companies);
    if(this.slides.getActiveIndex() == 3 && (this.introWizard.bgm || !this.companies.length)) {
      this.navCtrl.push(this.insurranceValidationPage)
    }

    if(this.slides.getActiveIndex() >= 4) {
      this.navCtrl.push(this.insurranceValidationPage)
    }
    this.slides.slideNext();
  }
  prevPage() {
    this.slides.slidePrev();
  }

  showCalculator() {
    this.visibleCalculator = true;
  }

  hideCalculator() {
    this.visibleCalculator = false;
  }

  slideWillChange(e) {
    console.log(this.introWizard);
    setTimeout(() => {
      this.rootClass = 'current-step-'+this.slides.getActiveIndex();
      this.currentSlide = this.slides.getActiveIndex();
    });
  }

  goToSlide(num: number) {
    this.slides.slideTo(num);
  }

  chooseCompanyPopup() {

    let companiesSimple = this.companies.map((row) => {
      return {description: row.name, name: row.name, free: row.free, payoutAmount: row.payoutAmount, infoText: row.infoText}
    });;

    console.log(companiesSimple);


    this.selector.show({
          title: this.contentTranslation.translateContent('Select company'),
          positiveButtonText: this.contentTranslation.translateContent('Wheel OK'),
          negativeButtonText: this.contentTranslation.translateContent('Wheel Cancel'),
          items: [
              companiesSimple
          ],
      }).then(
          result => {
            this.companyChanged(companiesSimple[result[0].index]);
            this.selectedCompany = companiesSimple[result[0].index].name;
          },
          err => console.log('Error: ', err)
      );

  }
}



// WEBPACK FOOTER //
// ./src/pages/intro-welcome/intro-welcome.ts